'use client';

import { cn } from '@/lib/utils/css';
import Image from 'next/image';
import Link from 'next/link';
import { Suspense, useCallback, useState } from 'react';
import StoreSearch from '../store-search';
import MobileMenu from './mobile-menu';
import MobileMenuButton from './mobile-menu-button';
import useHideNavbar from './useHideNavbar';
import dynamic from 'next/dynamic';

const AuthSection = dynamic(() => import('./auth-section'), { ssr: false });

export function Navbar() {
  const navbarVisible = useHideNavbar();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const handleClose = useCallback(() => {
    setIsMobileMenuOpen(false);
  }, []);

  return (
    <nav
      className={cn(
        'fixed top-0 left-0 z-10 w-full bg-white transition-transform duration-300',
        {
          'max-md:h-screen': isMobileMenuOpen,
          'translate-y-0': navbarVisible,
          '-translate-y-full': !navbarVisible,
        },
      )}
    >
      <div className="shadow-xs">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-5 px-3 lg:px-8">
          <div className="shrink-0 md:block">
            <Link href="/">
              <Image
                className="mt-2 hidden md:block"
                priority
                src={'/logo.png'}
                alt="Logo"
                width={250}
                height={34}
              />
              <Image
                className="ml-3 md:hidden"
                src={'/logo-mini.png'}
                alt="Logo"
                priority
                width={40}
                height={42}
              />
            </Link>
          </div>
          <div className="w-96 md:ml-10">
            <StoreSearch onSearchChanged={handleClose} />
          </div>
          <div className="ml-auto hidden md:block">
            <div className="ml-10 flex items-baseline space-x-4 text-sm font-medium">
              <Suspense fallback={null}>
                <AuthSection />
              </Suspense>
            </div>
          </div>
          <div className="flex md:hidden">
            <MobileMenuButton isOpen={isMobileMenuOpen} onClick={toggleMenu} />
          </div>
        </div>
      </div>

      {/* Mobile menu, show/hide based on menu state */}
      {isMobileMenuOpen && <MobileMenu />}
    </nav>
  );
}
